<h3 mat-dialog-title>Machinery</h3>

<mat-dialog-content>
    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>Machinery Name</mat-label>
            <input matInput type="text" name="machinery_name" [(ngModel)]="trailMachinery.machinery_name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Maintenance checked?</mat-label>
            <mat-select name="maintenance_check" [(ngModel)]="selectedState">
                @for (state of checkedStates; track state) {
                <mat-option [value]="state">{{state.expression}}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Outstanding Maintenance</mat-label>
            <textarea matInput type="text" name="outstanding_maintenance"
                [(ngModel)]="trailMachinery.outstanding_maintenance"></textarea>
        </mat-form-field>

        <table class="example-full-width" cellspacing="0">
            <tr>
                <td><mat-form-field class="example-full-width">
                        <mat-label>last oil-analysis date</mat-label>
                        <input matInput type="date" name="last_oil_analysis_date"
                            [(ngModel)]="trailMachinery.last_oil_analysis_date">
                        <mat-hint>DD/MM/YYYY</mat-hint>
                    </mat-form-field></td>
                <td><mat-form-field class="example-full-width">
                        <mat-label>running hours at present</mat-label>
                        <input matInput type="number" name="running_hours_at_present"
                            [(ngModel)]="trailMachinery.running_hours_at_present">
                    </mat-form-field></td>
            </tr>
        </table>

        <mat-form-field class="example-full-width">
            <mat-label>last oil analysis result</mat-label>
            <textarea matInput type="text" name="last_oil_analysis_result"
                [(ngModel)]="trailMachinery.last_oil_analysis_result"></textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>last major overhaul</mat-label>
            <textarea matInput type="text" name="last_major_overhaul" [(ngModel)]="trailMachinery.last_major_overhaul"></textarea>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="trailMachinery" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>